import { useQuery } from '@tanstack/react-query'
import type { ResponseApiError } from '../../../models/axios-error'
import axios, { type AxiosRequestConfig, type AxiosResponse } from 'axios'
import type { UseQueryOptionsWithoutQueryKey } from '../../../react-query-config'
import type { AggregationLevel, Channel } from '../home.model'

export interface UseApiGetAnnualCommitmentMonitoringRequest {
  channel: Channel
  aggregation: AggregationLevel
  storeId: number
  teamId: number | null
}

export interface AnnualCommitmentMonitoringValues {
  realizedGmv: number | null
  forecastedGmv: number | null
  spentHours: number | null
  forecastedHours: number | null
}

const getAnnualCommitmentMonitoring = async (config: AxiosRequestConfig): Promise<AnnualCommitmentMonitoringValues> => {
  const axiosPromise: AxiosResponse<AnnualCommitmentMonitoringValues> = await axios(config)
  return {
    realizedGmv: axiosPromise.data?.realizedGmv,
    forecastedGmv: axiosPromise.data?.forecastedGmv,
    spentHours: axiosPromise.data?.spentHours,
    forecastedHours: axiosPromise.data?.forecastedHours
  }
}

export const useApiGetAnnualCommitmentMonitoring = (
  args: UseApiGetAnnualCommitmentMonitoringRequest,
  enabled: boolean,
  options?: UseQueryOptionsWithoutQueryKey<AnnualCommitmentMonitoringValues>
) => {
  const { storeId, teamId, channel, aggregation } = args
  const teamParam = aggregation === 'TEAM' && teamId !== null ? `&teamId=${teamId}` : ''
  const url = `/annual-commitment-monitoring?aggregation=${aggregation}&channel=${channel}&storeId=${storeId}${teamParam}`
  const config: AxiosRequestConfig = { method: 'get', url }

  return useQuery<AnnualCommitmentMonitoringValues, ResponseApiError>({
    queryKey: ['get-annual-commitment-monitoring', url],
    queryFn: () => getAnnualCommitmentMonitoring(config),
    enabled,
    ...options
  })
}
